import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'xp-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
export class HomeComponent implements OnInit {

  constructor() {
  }

  public ngOnInit(): void {
  }

  public onButtonClick(): void {
    console.log('Button clicked');
  }

}
